import photo1 from "/public/images/events/coupes&open/open-rosny-18/photo1.webp";

export const openRosny18Images = [
  {
    src: photo1,
    alt: "Open Rosny 2018 - Photo 1",
    format: "3:2" as const,
  },
];
